import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Chevron"
      d="M9 1.16602L5 5.16602L1 1.16602"
      stroke="#9094A5"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

export const CaretDown = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
